'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function AuthError({ error, reset }: ErrorProps) {
  const router = useRouter();

  useEffect(() => {
    console.error("Auth error:", error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
      <h2 className="text-2xl font-semibold text-primary-600">Oops! Something went wrong</h2>
      <p className="mt-4 text-sm text-muted-foreground">
        {error.message || "An unexpected error occurred while handling your authentication request."}
      </p>
      <div className="mt-6 flex gap-4">
        <button
          onClick={() => reset()}
          className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-400"
        >
          Try again
        </button>
        <button
           onClick={() => router.push("/sign-in")}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-100"
        >
          Go to sign in
        </button>
      </div>
    </div>
  );
}
